import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { AuthService } from '../../services/auth.service';
import { LoginService } from '../../services/login.service';
import { MatDialog } from '@angular/material/dialog';
import { WelcomeComponent } from '../../parkifly-bookings/components/welcome/welcome.component';
import { BookingConfigService } from '../../../app/parkifly-bookings/services/booking-config.service';
import { ActivatedRoute } from '@angular/router';
import { FormService } from '../../parkifly-bookings/organizations/features/booking/components/form/service';

@Component({
  selector: 'app-landing-page-2',
  templateUrl: './landing-page-2.component.html',
  styleUrls: ['./landing-page-2.component.css'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [FormService]
})
export class LandingPageComponent2 implements OnInit {

  site: any;

  constructor(
    public translate: TranslocoService,
    private authService: AuthService,
    private loginService: LoginService,
    public dialog: MatDialog,
    private bookingConfigService: BookingConfigService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    localStorage.removeItem('quality-public');
    localStorage.removeItem('aiden-public');

    this.route.paramMap.subscribe(params => {
      this.bookingConfigService.setOrganizationFromUrl();
      this.site = this.bookingConfigService.getConfig().site;
    });

    if (!this.authService.loggedIn() && this.loginService.showPopupValue === true) {
      this.dialog.open(WelcomeComponent, {
        width: '500px',
        disableClose: false,
        panelClass: 'welcome-dialog'
      });
    }
  }

  scrollToElement($element: HTMLElement): void {
    $element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }
}
